const translations = {
    noMixesFound: 'No chemical mixes found',
    search: 'Search'
};

export default translations;
